import React, {useState, useEffect} from "react";
import withTheme from "utils/withTheme";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import styles from "./styles";
import {ContentHeader, CrudDialog} from "../../Common";
import {CustomerService} from "../../../services/Api/customers";
import {domainLevelConfig} from "../../../ui-config";
import {useSnackbar} from "notistack";
import {handleServerErrors} from "../../../helpers";
import {compose} from "redux";
import {connect} from "react-redux";
import {useNavigate} from "react-router";
import {SecretsService} from "../../../services";
import Box from "utils/Box";
import { Button, Card, IconButton, Typography } from "@mui/material";
import _ from "lodash";
import usePeerDevice from "./hooks/usePeerDevice";
import DeleteIcon from "@mui/icons-material/HighlightOff";

const Provisioning = (props) => {
    const navigate = useNavigate();
    const classes = styles();
    const [addModal, setAddModal] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const {enqueueSnackbar} = useSnackbar();
    const [serialNumber, setSerialNumber] = useState("");
    const [deviceName, setDeviceName] = useState("");

    const [operatorsList, setOperatorsList] = useState([]);

    // const [parentDevice, setParentDevice] = useState("");
    const [value, setValue] = React.useState("");
    const [inputValue, setInputValue] = React.useState("");
    const [inputOperatorValue, setInputOperatorValue] = React.useState("");
    const [operatorValue, setOperatorValue] = React.useState(null);

    const [isMutating, setIsMutating] = useState(false);

    const [moduleNumber, setModuleNumber] = useState(null);
    const [isMSeriesSelected, setIsMSeriesSelected] = useState(false);
    const [isExistingVM, setIsExistingVM] = useState(false);

    const {
        peerDevices,
        addPeerDevice,
        removePeerDevice,
        updatePeerDevice,
        handleSearch,
        closeDiscardDialog,
        discardDialog,
        mergePeerDevices,
        discardPeerDevices,
    } = usePeerDevice({
        props: {
            deviceTypeList: categoryList,
        },
        onResponse: (deviceInfo) => {
            if(deviceInfo.operator_id) {
                setInputOperatorValue(_.find(props.currentUser.operators, x => x.id === deviceInfo.operator_id)?.business_name);
                setOperatorValue(deviceInfo.operator_id);
            }

            if(deviceInfo.device_type_id) {
                setInputValue(_.find(categoryList, x => x.id === deviceInfo.device_type_id)?.device_type);
                setValue(deviceInfo.device_type_id);
            }

            if(deviceInfo.vm_name) {
                setDeviceName(deviceInfo.vm_name)
            }

            if(deviceInfo.module_number) {
                setModuleNumber(deviceInfo.module_number);
                setIsMSeriesSelected(true);
                setIsExistingVM(true);
            } else {
                setModuleNumber(null);
                setIsMSeriesSelected(false);
                setIsExistingVM(false);
            }
        }
    });

    // validations
    const [validation, setValidation] = React.useState({
        serialNumber: false,
        // parentDevice: false,
    });
    const [peerValidation, setPeerValidation] = useState({
        id: '',
        serialNumber: false,
    });

    // Start Validation
    const SerialValidation = (field = "") => {
        var unicast = ["00:00:5E", "00:00-5E", "00-00-5E", "00-00:5E"];
        var multicast = ["01:00:5E", "01:00-5E", "01-00-5E", "01-00:5E"];
        if (
            field.match(/^(?:[A-Fa-f0-9]{2}[:-]){5}(?:[A-Fa-f0-9]{2})$/) ||
            unicast.indexOf(field.substring(0, 8).toUpperCase()) >= 0 ||
            multicast.indexOf(field.substring(0, 8).toUpperCase()) >= 0
        ) {
            return false;
        } else if (field.length === 12) {
            return false;
        } else {
            return true;
        }
    };

    const getCategory = () => {
        CustomerService.getCategory({all: true, ordering: "category_name"})
            .then(({data = {}}) => {
                setCategoryList(data.results);
            })
            .catch((err) => {
                if (err.detail) {
                    enqueueSnackbar(err.detail);
                } else {
                    handleServerErrors(
                        err,
                        enqueueSnackbar,
                        "Could not get categories. Try again."
                    );
                }
            });
    };

    const getOperators = async () => {
        try {
            const {data} = await window.axiosIns('company', {params: {all: true, ordering: "business_name"}});
            setOperatorsList(data.data.results);
        } catch(err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getCategory();
        getOperators();

        window.setTimeout(() => {
            window.localStorage.setItem("jsonData", "");
        }, 5000);
    }, []);

    const handleSerialNumberChange = (e) => {
        const value = e.target.value;
        const v = SerialValidation(value);

        setValidation({serialNumber: v});
        setSerialNumber(value);

        if (!v) {
            setDeviceName("");
            setInputValue("");
            setModuleNumber(null);
            setIsExistingVM(false);
            setIsMSeriesSelected(false);
            handleSearch(value);
        }
    };

    const handlePeerSerialNumberChange = (id, peer_serial_number, value) => {
        const v = SerialValidation(value);
        setPeerValidation({serialNumber: v,id:id});
        updatePeerDevice(id, peer_serial_number, value);
    };

    // const handleParentDeviceChange = (e) => {
    //   const value = e.target.value;
    //   const v = SerialValidation(value);
    //
    //   setValidation({ ...validation, parentDevice: v });
    //   setParentDevice(value);
    // };

    const handleSubmit = (e) => {
        e.preventDefault();
        handleAdd();
    };

    const reprovisionHandleAdd = () => {
        const data = {
            serial_number: serialNumber,
            device_type: value,
            vm_name: deviceName,
            operator_id: operatorValue,
            module_number: moduleNumber ? Number(moduleNumber) : null,
            peer_devices: _.map(peerDevices, x => ({
                peer_serial_number: x.peer_serial_number,
                peer_device_type: x.peer_device_type,
                num_chambers: x.num_chambers,
                capacity_per_chamber: x.capacity_per_chamber,
            })),
            // parent_serial_number: parentDevice,
        };
        SecretsService.create(data)
            .then(({data: resData}) => {
                localStorage.setItem("jsonData", JSON.stringify(resData || {}));
                setAddModal(false);
                enqueueSnackbar("Machine successfully re-provisioned.");
                window.setTimeout(() => {
                    window.location.reload();
                }, 2000);
            })
            .catch((error) => {
                if (error && error.response && error.response.status === 306) {
                    enqueueSnackbar(
                        "Device credentials could not be added. Device with Serial number already registered."
                    );
                } else {
                    handleServerErrors(
                        error,
                        enqueueSnackbar,
                        "Device credentials could not be added."
                    );
                }
            });
    };

    const handleAdd = () => {
        setIsMutating(true);
        const data = {
            serial_number: serialNumber,
            device_type: value,
            vm_name: deviceName,
            operator_id: operatorValue,
            module_number: moduleNumber ? Number(moduleNumber) : null,
            peer_devices: _.map(peerDevices, x => ({
                peer_serial_number: x.peer_serial_number,
                peer_device_type: x.peer_device_type,
                num_chambers: x.num_chambers,
                capacity_per_chamber: x.capacity_per_chamber,
            })),
            // parent_serial_number: parentDevice,
        };
        SecretsService.create(data)
            .then(({data: resData}) => {
                if (resData?.is_device_exists === true) {
                    setAddModal(true);
                } else {
                    localStorage.setItem("jsonData", JSON.stringify(resData || {}));
                    setAddModal(false);
                    enqueueSnackbar("Machine successfully provisioned.");
                    window.setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                }
            })
            .catch((error) => {
                if (error && error.response && error.response.status === 306) {
                    enqueueSnackbar(
                        "Device credentials could not be added. Device with Serial number already registered."
                    );
                } else {
                    handleServerErrors(
                        error,
                        enqueueSnackbar,
                        "Device credentials could not be added."
                    );
                }
            }).finally(() => {
            setIsMutating(false);
        });
    };

    const hostConfig =
        domainLevelConfig[props.host] || domainLevelConfig["default"] || {};

    return (
        <div className={classes.wrapper}>
            {/** to transfer the data to android through web view
             * we are using this div for that
             */}
            <div id="provisioning" style={{display: "none"}}>
                {localStorage.jsonData}
            </div>
            <ContentHeader
                description={
                    <div>
                        <p style={{margin: 0}}>
                            Register the Device and Credential Secret from Serial Number for
                            the devices manufactured.
                        </p>
                        <br/>
                        <p style={{margin: 0}}>
                            Serial Number should be 12 characters long excluding : and -
                        </p>
                        <p style={{margin: 0}}>
                            Example Serial Numbers: 5A-83-74-BB-5F-2D, 5A:83:74:BB:5F:2D
                        </p>
                    </div>
                }
                title="SN Management"
            />
            <div className={classes.content}>
                {/* start */}
                <form style={{maxWidth: 'min-content'}} onSubmit={handleSubmit}>
                    <TextField
                        error={validation?.serialNumber}
                        helperText={
                            validation?.serialNumber && <p>Serial Number should be a valid MAC address.</p>
                        }
                        className={classes.field}
                        id="serial_number"
                        label="Serial Number"
                        required
                        variant="outlined"
                        onChange={handleSerialNumberChange}
                    />
                     <TextField
                        className={classes.field}
                        id="device_name"
                        label="Device Name"
                        value={deviceName}
                        required
                        variant="outlined"
                        onChange={(e)=>setDeviceName(e.target.value)}
                    />
                    {props.currentUser.type === "SA" && (
                        <Autocomplete
                            className={classes.field}
                            id="operator"
                            // value={value}
                            onChange={(event, newValue) => {
                                setOperatorValue(newValue?.id);
                            }}
                            inputValue={inputOperatorValue}
                            onInputChange={(event, newInputValue) => {
                                setInputOperatorValue(newInputValue);
                            }}
                            options={operatorsList || []}
                            getOptionLabel={(option) => option.business_name}
                            style={{width: 300}}
                            renderInput={(params) => (
                                <TextField {...params} label="Operator" variant="outlined"/>
                            )}
                        />
                    )}
                    <Autocomplete
                        className={classes.field}
                        id="device_type"
                        // value={value}
                        onChange={(event, newValue) => {
                            setValue(newValue?.id);
                        }}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                            if (newInputValue === "M Series") {
                                setIsMSeriesSelected(true);
                            } else {
                                setIsMSeriesSelected(false);
                            }
                            setInputValue(newInputValue);
                        }}
                        options={categoryList || []}
                        getOptionLabel={(option) => option.device_type}
                        style={{width: 300}}
                        renderInput={(params) => (
                            <TextField required {...params} label="Type" variant="outlined"/>
                        )}
                        disabled={isExistingVM && isMSeriesSelected}
                    />

                    {isMSeriesSelected &&
                        <TextField
                         className={classes.field}
                         id="module_number"
                         type="number"
                         label="Modules Count"
                         value={moduleNumber}
                         required={isMSeriesSelected ? true : false}
                         variant="outlined"
                         onChange={(e)=>setModuleNumber(e.target.value)}
                         slotProps={{ input: { inputProps: { min: 1, max: 10 } } }}
                         disabled={isExistingVM && isMSeriesSelected}
                     />
                    }

                    {peerDevices.map((x, i) => (
                        <Card
                            key={x.id}
                            style={{padding: 5, margin: 8, paddingTop: 35, position: "relative"}}
                            variant="outlined"
                        >
                            <Typography style={{position: 'absolute', top: 6, left: 20}} variant={"body2"}>
                                <b>
                                    Peer Device - {i + 1}
                                </b>
                            </Typography>
                            <IconButton
                                onClick={() => removePeerDevice(x.id)}
                                color="primary"
                                variant="outlined"
                                aria-label="delete"
                                className={classes.deleteButton}
                                size="large">
                                <DeleteIcon/>
                            </IconButton>

                            <TextField
                                error={peerValidation.id == x.id ? peerValidation?.serialNumber : false}
                                helperText={peerValidation.id == x.id ?
                                    peerValidation?.serialNumber && <p>Serial Number should be a valid MAC address.</p>
                                    :null
                                }
                                className={classes.field}
                                style={{
                                    marginTop: 5
                                }}
                                value={x.peer_serial_number || ""}
                                id="peer_serial_number"
                                label="Serial Number"
                                required
                                variant="outlined"
                                onChange={(e) => {
                                    handlePeerSerialNumberChange(x.id, "peer_serial_number", e.target.value)
                                }}
                            />

                            <Autocomplete
                                className={classes.field}
                                id="device_type_input"
                                onChange={(__, y) => {
                                    updatePeerDevice(x.id, 'peer_device_type', y?.id || null);
                                    updatePeerDevice(x.id, 'device_type_input', _.find(categoryList, (z) => z?.id === y?.id)?.device_type || "");
                                }}
                                options={categoryList}
                                getOptionLabel={(option) => option.device_type}
                                inputValue={x.device_type_input}
                                onInputChange={(__, val) => {
                                    if(__) {
                                        updatePeerDevice(x.id, 'device_type_input', val);
                                    }
                                }}
                                openOnFocus={true}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        required
                                        label="Device Type"
                                        variant="outlined"
                                    />
                                )}
                            />
                            <TextField
                                className={classes.field}
                                id="num_chambers"
                                label="Number of locker chambers"
                                type={"number"}
                                value={x.num_chambers || ""}
                                required
                                variant="outlined"
                                onChange={(e) => {
                                    updatePeerDevice(x.id, "num_chambers", e.target.value)
                                }}
                            />
                            <TextField
                                className={classes.field}
                                id="capacity_per_chamber"
                                value={x.capacity_per_chamber || ""}
                                label="Capacity per locker chamber"
                                required
                                type={"number"}
                                variant="outlined"
                                onChange={(e) => {
                                    updatePeerDevice(x.id, "capacity_per_chamber", e.target.value)
                                }}
                            />

                        </Card>
                    ))}

                    <Box>
                        <Button
                            className={classes.addButton}
                            variant="contained"
                            style={props.currentUser.type !== "SU" ? {
                                backgroundColor: hostConfig.themeColor
                                    ? hostConfig.themeColor
                                    : "#39A8E0",
                                color: "white",
                            } : {}}
                            onClick={() => addPeerDevice(1)}
                        >
                            Add {peerDevices.length ? "another peer" : "a peer"} device
                        </Button>
                    </Box>

                    <Button
                        type="button"
                        onClick={() => navigate("/machinedashboard")}
                        variant="outlined"
                        color="primary"
                        className={classes.formButton}
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={props.currentUser.type === 'SU' || isMutating}
                        className={classes.formButton}
                        type="submit"
                        variant="contained"
                        style={props.currentUser.type !== "SU" ? {
                            backgroundColor: hostConfig.themeColor
                                ? hostConfig.themeColor
                                : "#39A8E0",
                            color: "white",
                        } : {}}


                    >
                        Provision
                    </Button>
                </form>
                <CrudDialog
                    title="Re-Provision:"
                    okText="Re-Provision"
                    description="This device is already provisioned. Do you want to re-provision?"
                    // fields={fields}
                    onSubmit={() => reprovisionHandleAdd()}
                    open={addModal}
                    onClose={() => setAddModal(false)}
                />

                <CrudDialog
                    title="Discard changes"
                    description="There are upcoming changes, do you want to discard current changes ?"
                    cancelText="Merge"
                    okText="Discard"
                    onCancel={() => mergePeerDevices()}
                    onSubmit={() => discardPeerDevices()}
                    open={discardDialog}
                    onClose={closeDiscardDialog}
                />

                {/* end */}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.userReducer.current_user,
        host: state.userReducer.host,
    };
};

export default compose(withTheme, connect(mapStateToProps))(Provisioning);
